import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { ORG_NAME, ORG_FULL_NAME, ORG_EMAIL_BOOKINGS, ORG_PHONE_RAW } from "../constants";

const Footer = () => {
  return (
    <footer className="border-t-4 border-black bg-muted py-8 mt-12" data-testid="global-footer">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Left Section */}
          <div>
            <h3 className="text-lg font-syne font-bold mb-2 notranslate" translate="no">{ORG_FULL_NAME}</h3>
            <p className="text-sm text-muted-foreground">Managed by <span className="notranslate" translate="no">{ORG_NAME}</span></p>
          </div>

          {/* Center Section - Quick Links */}
          <div>
            <h3 className="text-lg font-syne font-bold mb-2">Quick Links</h3>
            <div className="space-y-2">
              <Link
                to="/dashboard"
                className="block text-sm font-bold hover:text-primary transition-colors"
                data-testid="footer-dashboard-link"
              >
                My Dashboard
              </Link>
              <Link
                to="/help"
                className="block text-sm font-bold hover:text-primary transition-colors"
                data-testid="footer-help-link"
              >
                Help & FAQ
              </Link>
              <button
                onClick={() => {
                  const event = new CustomEvent('openPDPA');
                  window.dispatchEvent(event);
                }}
                className="block text-sm font-bold hover:text-primary transition-colors text-left"
                data-testid="footer-pdpa-link"
              >
                Privacy Policy (PDPA)
              </button>
            </div>
          </div>

          {/* Right Section - Contact Support */}
          <div>
            <h3 className="text-lg font-syne font-bold mb-2">Contact Support</h3>
            <div className="space-y-2">
              <a
                href={`mailto:${ORG_EMAIL_BOOKINGS}`}
                className="flex items-center gap-2 text-sm font-bold hover:text-primary transition-colors"
                data-testid="footer-email-link"
              >
                <Mail size={16} />
                {ORG_EMAIL_BOOKINGS}
              </a>
              <a
                href={`tel:${ORG_PHONE_RAW}`}
                className="flex items-center gap-2 text-sm font-bold hover:text-primary transition-colors"
                data-testid="footer-phone-link"
              >
                <Phone size={16} />
                {ORG_PHONE_RAW}
              </a>
            </div>
            <p className="text-xs text-muted-foreground mt-3">
              For payment appointments or booking overrides, please call or email us with your Booking ID.
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-4 border-t-2 border-black text-center">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} <span className="notranslate" translate="no">YCK Court RN Karaoke</span>. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
